module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Index"
  }, [_c('starry-bg'), _vm._v(" "), _c('div', {
    staticClass: "box__planets",
    style: ({
      height: _vm.planetBoxHeight
    })
  }, [_c('div', {
    staticClass: "box__innerPlanets",
    style: ({
      initInnerHeight: _vm.initInnerHeight
    })
  }, _vm._l((_vm.planet_datas), function(planet, index) {
    return _c('planet', {
      key: planet.name_en,
      attrs: {
        "planetIndex": index,
        "planetOpen": _vm.planet_open,
        "name_en": planet.name_en,
        "name_zh": planet.name_zh,
        "color_planet": planet.color_planet,
        "color_planet_shadow": planet.color_planet_shadow,
        "color_name": planet.color_name
      },
      on: {
        "openPlanet": _vm.openPlanet
      }
    })
  })), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "box__detail",
    style: ({
      pointerEvents: _vm.planet_open ? 'initial' : 'none'
    })
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.planet_open),
      expression: "planet_open"
    }],
    staticClass: "btn__closePlanet",
    attrs: {
      "src": require("./images/repeat.svg"),
      "alt": ""
    },
    on: {
      "click": _vm.closePlanet
    }
  }), _vm._v(" "), _c('skill-detail', {
    attrs: {
      "planetOpen": _vm.planet_open == _vm.planet_datas[0].name_en,
      "planetColor": _vm.planet_datas[0].color_planet
    },
    on: {
      "updatePlanetBoxHeight": _vm.updatePlanetBoxHeight
    }
  }), _vm._v(" "), _c('works-detail', {
    attrs: {
      "planetOpen": _vm.planet_open == _vm.planet_datas[1].name_en,
      "planetColor": _vm.planet_datas[1].color_planet
    },
    on: {
      "updatePlanetBoxHeight": _vm.updatePlanetBoxHeight
    }
  }), _vm._v(" "), _c('aboutme-detail', {
    attrs: {
      "planetOpen": _vm.planet_open == _vm.planet_datas[2].name_en,
      "planetColor": _vm.planet_datas[2].color_planet
    },
    on: {
      "updatePlanetBoxHeight": _vm.updatePlanetBoxHeight
    }
  })], 1), _vm._v(" "), (_vm.cover_mount) ? _c('svg-cover', {
    on: {
      "unmountCover": _vm.unmountCover
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box__link"
  }, [_c('a', {
    attrs: {
      "href": "mailto:sunrise91.t3@gmail.com"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("./images/icons/envelop.svg"),
      "alt": "email icon"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://github.com/GoreStarry"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("./images/icons/github.svg"),
      "alt": "github icon"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:+886988104329"
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("./images/icons/phone2.svg"),
      "alt": "phone icon"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65fa0e4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/container/index/Index.vue
// module id = 64
// module chunks = 0